import axios, { type AxiosInstance } from 'axios';
import { getAccessToken, applyAuthTokenInterceptor } from 'axios-jwt';
import useAuthStore from '@/store/AuthStore';
import useCommonStore from '@/store/CommonStore';
import { BASE_URL, LOGOUT_URL } from '@/Constants';
import { requestRefresh } from '@/api/AuthApi';

export default class CoreApi {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static commonStore: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static authStore: any;
  public static axiosClient: AxiosInstance = axios.create({
    baseURL: BASE_URL,
  });

  public static initialize() {
    this.commonStore = useCommonStore();
    this.authStore = useAuthStore();
    this.axiosClient.interceptors.request.use(
      async (config) => {
        const currentUserAccessToken = await getAccessToken();
        if (currentUserAccessToken) {
          config.headers['Authorization'] = `Bearer ${currentUserAccessToken}`;
        }
        return config;
      },
      (error) => {
        Promise.reject(error);
      },
    );
    applyAuthTokenInterceptor(this.axiosClient, { requestRefresh });

    // Global 403, 401 -> LOGOUT redirect
    this.axiosClient.interceptors.response.use(
      (response) => response,
      async (error) => {
        const status = error?.response?.status;
        if (status === 403 || status === 401) {
          try {
            await this.authStore.logoutAndClearUserData();
          } catch {
            window.location.replace(LOGOUT_URL);
          }
        }
        return Promise.reject(error);
      },
    );
  }
}
